export const DISABLE_KEYS = ['F12'];
export const DISABLE_KEYS_WITH_CTRL = ['p', 's', 'u']; // Print, Save, View page source
export const DISABLE_KEYS_WITH_CTRL_SHIFT = ['I', 'J', 'C', 'V', 'S']; // Developers tools, inspect elements, copy, paste, save

export const DISABLED_KEY_EVENT_MSG = 'Action is disabled.';
